import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initBlogLoadMore from '../sections/blog/initLoadMore';
import initCategoryScrollIndicator from '../sections/blog/initCategoryScrollIndicator';

ready(() => {
  initBlogLoadMore();
  initCategoryScrollIndicator();
});

onShopifySectionLoad(() => {
  initBlogLoadMore();
  initCategoryScrollIndicator();
});
